<template>
  <div class="ai">
    <div id="ai_body" class="aiScreenview">
      <header class="header-style">
        <i class="material-icons" @click="closeUI" id="back-btn">keyboard_backspace</i>
        <h4 class="head_title">Mall91 AI</h4>
      </header>
      <section class="chat aimidContent">
        <div class="container cstm_conatiner">
          <div class="incoming_msg">
            <div class="msg_cntnt">
              <p>आप क्या खरीदना चाहते है</p>
              <span></span>
            </div>
          </div>
        </div>
      </section>
      <a v-if="showMic" class="ai_btn">
        <i class="material-icons">mic</i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AI",
  props: {
    openAI: {
      type: Boolean
    }
  },
 
  created(){

  },
  data() {
    return {
      isOpen: false,
      showMic: true
    };
  },
  methods: {
    openUI() {
      if (
        this.$cookie.get("app-name") != null ||
        this.$cookie.get("lang") != null ||
        this.$cookie.get("X-Auth-Token") != null
      ) {
        try {
          JSBridgePlugin.showNativeMic();
          _AI.initialized = true;
          _AI.detailCallback = this.openDetailsPage
        } catch (e) {
          console.log("JS Bridge not found");
        } finally {
          this.showMic = false;
        }
      }

      if (!_AI.initialized) {
        _AI.init(this.openDetailsPage);
        _AI.initialized = true;
      } else {
        _AI.speak("आप क्या खरीदना चाहते है", _AI.openMicExplicitly);
      }
    },
    closeUI() {
      this.$emit('closeAiPage',false)
      if (
        this.$cookie.get("app-name") != null ||
        this.$cookie.get("lang") != null ||
        this.$cookie.get("X-Auth-Token") != null
      ) {
        try {
          JSBridgePlugin.hideNativeMic();
        } catch (e) {
          console.log("JS Bridge not found");
        }
      } else {
        _AI.stopCapture();
      }
    },
    openDetailsPage: function(id) {
      this.closeUI();
      var _this = this;
      setTimeout(function() {
        _this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
        _this.$router.push("/detail/" + id + '?source=VOICE_SEARCHING');
      }, 100);
    },
  },

  mounted() {
     this.openUI()   
  }
};
</script>
